import { datadogLogs } from '@datadog/browser-logs';

import { __DEV__ } from '@toolbox/utils';

import type { LogsInitConfiguration } from '@datadog/browser-logs';

declare global {
  interface Window {
    DD_LOGS?: typeof datadogLogs;
  }
}

function init(config: LogsInitConfiguration): void {
  datadogLogs.init(config);
}

function setContextProperty(key: string, property: unknown) {
  datadogLogs.setGlobalContextProperty(key, property);
}

function getContextProperty(key: string) {
  return datadogLogs.getGlobalContext()[key];
}

function removeContextProperty(key: string) {
  datadogLogs.removeGlobalContextProperty(key);
}

/**
 * Registers and event using dd api
 */
function registerEvent(event: unknown): void {
  if (typeof window !== 'undefined' && window.DD_LOGS) {
    datadogLogs.logger.log(JSON.stringify(event));
  } else {
    // eslint-disable-next-line no-console
    console.warn('DD is not registered');
  }
}

// TODO - create context enum, to have it defined/predicted
function registerError(errorData: unknown, context?: string): void {
  if (typeof window !== 'undefined' && window.DD_LOGS) {
    if (__DEV__) {
      // eslint-disable-next-line no-console
      console.error(errorData);
    }

    datadogLogs.logger.error(
      JSON.stringify({
        context,
        path: window.location.pathname,
        message: isLogDataContainsMessage(errorData) ? errorData.message : undefined,
        errorData,
      }),
    );
  } else {
    // eslint-disable-next-line no-console
    console.warn('DD is not registered');
  }
}

// TODO - create context enum, to have it defined/predicted
function registerWarn(warnData: unknown, context?: string): void {
  if (typeof window !== 'undefined' && window.DD_LOGS) {
    if (__DEV__) {
      // eslint-disable-next-line no-console
      console.warn(warnData);
    }

    datadogLogs.logger.warn(
      JSON.stringify({
        context,
        path: window.location.pathname,
        message: isLogDataContainsMessage(warnData) ? warnData.message : undefined,
        warnData,
      }),
    );
  } else {
    // eslint-disable-next-line no-console
    console.warn('DD is not registered');
  }
}

function isLogDataContainsMessage(errorData: unknown): errorData is { message: string } {
  return typeof errorData === 'object' && errorData !== null && 'message' in errorData;
}

export const browserLogger = {
  init,
  log: registerEvent,
  error: registerError,
  warn: registerWarn,
  setContextProperty,
  getContextProperty,
  removeContextProperty,
};
